import httpClient from "@/plugins/axios";

export const getPiiriArticles = async () => {
    const response = await httpClient.get('/v1/articles/?page=1&page_size=100');
    return response;
}

export const getPiiriArticle = async (id) => {
    const response = await httpClient.get(`/v1/articles/${id}/`);
    return response;
}

